import { render } from "./CreateOrganisation.vue?vue&type=template&id=58b18b79"
import script from "./CreateOrganisation.vue?vue&type=script&lang=js"
export * from "./CreateOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__